export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginBottom: 24
  },
  component: {
    marginTop: 24
  },
  example: {
    marginTop: 24
  }
}



// WEBPACK FOOTER //
// ./src/docs/Example/styles.js